"use client"

import { SquareRadical } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareRadicalIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareRadicalIcon = component(Icon)({ as: SquareRadical })
